// @module Digi.SupportDocs.SupportDocs
define('IMEIManager.Model',
    [
        'Backbone'
    ],
    function (
        Backbone
    ) {
        'use strict';

        // @class Digi.SupportDocs.SupportDocs.View @extends Backbone.View
        return Backbone.Model.extend({

        });
    });
